export const fmt = (n: number) =>
  n.toLocaleString("ru-RU", { maximumFractionDigits: 0 })
export const fmtRub = (n: number) => fmt(n) + " ₽"
export const fmtPct = (n: number) => n.toFixed(1) + "%"
